import { useSelector } from "react-redux";
import CardComponent from "../card/cardComponent";
import FilterSecuestrosComponent from "../filter/filterSecuestros";
import CardSkeleton from "./cardSkeleton";

function CardsComponent({ loading, error, fetchSecuestros }) {
  const secuestros = useSelector((state) => state.secuestros);

  return (
    <div>
      <FilterSecuestrosComponent
        fetchSecuestros={fetchSecuestros}
      />

      <div className="grid grid-cols-1 mid:grid-cols-3 custom:grid-cols-2 gap-4 p-4">
        {loading ? (
          Array.from({ length: 9 }).map((_, index) => (
            <CardSkeleton key={index} />
          ))
        ) : error ? (
          <div className="col-span-full flex flex-col items-center justify-center py-16 text-center">
            <h2 className="text-lg font-semibold text-gray-700">
              No se pudieron cargar los registros
            </h2>

            <p className="mt-2 text-sm text-gray-500">
              Ocurrió un problema al comunicarse con el servidor.
            </p>
          </div>
        ) : (
          secuestros.map(
            ({
              id,
              Vehiculo,
              egreso,
              Acta,
              fecha_hora,
              foto,
              compactado,
              estado,
            }) => (
              <CardComponent
                key={id}
                tipo={Vehiculo?.tipovh}
                dominio={Vehiculo?.dominio}
                egreso={egreso}
                numeroActa={Acta?.nro}
                lugar={Acta?.lugar}
                fecha_hora={fecha_hora}
                foto={foto}
                compactado={compactado}
                estadoBd={estado}
                id={id}
              />
            )
          )
        )}
      </div>
    </div>
  );
}

export default CardsComponent;